import React from 'react';
import { useTranslation } from 'react-i18next';

const About: React.FC = () => {
  // @ts-ignore
  const { t } = useTranslation();

  return (
    <div className="page-container">
      {/* @ts-ignore */}
      <h1 className="page-title">{t('about.title')}</h1>
      
      <div className="about-hero">
        <div className="about-hero-content">
          {/* @ts-ignore */}
          <p className="about-lead">{t('about.content')}</p>
        </div>
      </div>

      <div className="about-content">
        <div className="about-image">
          <img src="/images/team.jpg" alt="Matrix Team" onError={(e) => {
            e.currentTarget.src = 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80';
          }} />
        </div>
        <div className="about-text">
          {/* @ts-ignore */}
          <h2>{t('about.mission')}</h2>
          {/* @ts-ignore */}
          <p>{t('about.mission_content')}</p>
          
          {/* @ts-ignore */}
          <h3>{t('about.history')}</h3>
          {/* @ts-ignore */}
          <p>{t('about.history_content')}</p>
          
          {/* @ts-ignore */}
          <h3>{t('about.values')}</h3>
          <ul className="values-list">
            <li>
              {/* @ts-ignore */}
              <strong>{t('about.values_items.innovation')}:</strong> {t('about.values_items.innovation_desc')}
            </li>
            <li>
              {/* @ts-ignore */}
              <strong>{t('about.values_items.excellence')}:</strong> {t('about.values_items.excellence_desc')}
            </li>
            <li>
              {/* @ts-ignore */}
              <strong>{t('about.values_items.collaboration')}:</strong> {t('about.values_items.collaboration_desc')}
            </li>
            <li>
              {/* @ts-ignore */}
              <strong>{t('about.values_items.integrity')}:</strong> {t('about.values_items.integrity_desc')}
            </li>
          </ul>
        </div>
      </div>
      
      <div className="team-section">
        {/* @ts-ignore */}
        <h2>{t('about.team')}</h2>
        <div className="team-grid">
          <div className="team-member">
            <div className="member-image">
              <img src="/images/team/jacky.svg" alt="CEO" />
            </div>
            {/* @ts-ignore */}
            <h3>{t('about.team_members.ceo.name')}</h3>
            {/* @ts-ignore */}
            <p className="member-title">{t('about.team_members.ceo.title')}</p>
            {/* @ts-ignore */}
            <p>{t('about.team_members.ceo.description')}</p>
          </div>
          
          <div className="team-member">
            <div className="member-image">
              <img src="/images/team/neo.svg" alt="CTO" />
            </div>
            {/* @ts-ignore */}
            <h3>{t('about.team_members.cto.name')}</h3>
            {/* @ts-ignore */}
            <p className="member-title">{t('about.team_members.cto.title')}</p>
            {/* @ts-ignore */}
            <p>{t('about.team_members.cto.description')}</p>
          </div>
          
          <div className="team-member">
            <div className="member-image">
              <img src="/images/team/maria.svg" alt="COO" />
            </div>
            {/* @ts-ignore */}
            <h3>{t('about.team_members.coo.name')}</h3>
            {/* @ts-ignore */}
            <p className="member-title">{t('about.team_members.coo.title')}</p>
            {/* @ts-ignore */}
            <p>{t('about.team_members.coo.description')}</p>
          </div>
        </div>
      </div>
      
      <div className="achievements-section">
        {/* @ts-ignore */}
        <h2>{t('about.achievements')}</h2>
        <div className="achievements-grid">
          <div className="achievement-card">
            <div className="achievement-icon">🏆</div>
            {/* @ts-ignore */}
            <h3>{t('about.achievements_items.projects.number')}</h3>
            {/* @ts-ignore */}
            <p>{t('about.achievements_items.projects.description')}</p>
          </div>
          
          <div className="achievement-card">
            <div className="achievement-icon">🌎</div>
            {/* @ts-ignore */}
            <h3>{t('about.achievements_items.countries.number')}</h3>
            {/* @ts-ignore */}
            <p>{t('about.achievements_items.countries.description')}</p>
          </div>
          
          <div className="achievement-card">
            <div className="achievement-icon">👥</div>
            {/* @ts-ignore */}
            <h3>{t('about.achievements_items.team.number')}</h3>
            {/* @ts-ignore */}
            <p>{t('about.achievements_items.team.description')}</p>
          </div>
          
          <div className="achievement-card">
            <div className="achievement-icon">⭐</div>
            {/* @ts-ignore */}
            <h3>{t('about.achievements_items.satisfaction.number')}</h3>
            {/* @ts-ignore */}
            <p>{t('about.achievements_items.satisfaction.description')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 